<template>
  <start-layer id="reviews" clip-waves-class="purple-gradient px-0" :offset=".75">
    <h4 class="text-center header-font text-sm-h4 px-3">
      Thousands of individuals, businesses, charities, schools, and non-profit organizations trust Ellacard
    </h4>

    <v-carousel class="v-carousel-transparent" light continuous Xcycle height="auto" :show-arrows="false">
      <v-carousel-item v-for="(r, i) in reviews" :key="i" eager>
        <quote-card class="absolute-fill px-6" v-bind="r" />

        <!-- This is quite the kludge, but the v-carousel does NOT compute its height properly based on its items, in spite of the 'eager' flag and the height="auto" setting (as suggested here: https://stackoverflow.com/questions/51067412/changing-the-vuetify-carousel-height ), so we render them all invisibly in an appropriately sized scrolling container so that it will determine its height correctly based off of the tallest element. -->
        <div
          class="overflow-auto d-flex"
          style="opacity: 0; padding-bottom: 50px; pointer-events: none; z-index: -1;"
          v-bind:style="{ width: (100 * reviews.length) + '%' }"
        >
          <div v-for="r in reviews" v-bind:style="{ width: (100 * reviews.length) + '%' }">
            <quote-card class="px-6" v-bind="r" />
          </div>
        </div>
      </v-carousel-item>
    </v-carousel>

  </start-layer>
</template>


<script>
import QuoteCard from '@/components/QuoteCard.vue';
import StartLayer from '@/components/StartLayer.vue';


const REVIEWS = [
  {
    name: "Drew Reiner",
    company: "Grapevine.ai",
    role: "CEO",
    text: "We use Ellacard for birthdays and special events at the office. Great product and their staff answer our questions promptly. It has definitely been a huge boost from the old days of passing around a card.",
    tags: [ "BU", "GR", "IN" ]
  },
  {
    name: "Aaron Marks",
    company: "Turnpoint Technology",
    role: "President and CTO",
    text: "We send Ellacards out for birthdays, work anniversaries, promotions, retirements, and more. Our employees love how easy it is to make a nice looking card with pictures and videos. Ellacard has contributed to building a culture of collaboration and appreciation that our employees love.",
    tags: [ "BU", "GR" ]
  },
  {
    name: "Shobhit K.",
    company: "Shyft Labs",
    role: "CEO",
    text: "We have been using Ellacard for quite a while now, and have nothing but positive things to say about the experience. It's simple, user-friendly, saves tons of time, and the customer support we have gotten has been second to none. I have personally recommended it to several peers and colleagues, and will continue to be a customer myself.",
    src: 'Capterra',
    link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6258605/",
    tags: [ "BU", "CO", "GR", "IN" ]
  },
  {
    name: "Anna S.",
    company: "B-Stock",
    role: "People operations associate",
    text: "I like that you can create bulk gift card orders and customize each out with any custom field you want. This allows our cards to feel customized and personal. It also allows us to use EllaCard for a variety of use cases, since the possibilities for custom fields are endless.",
    src: 'Capterra',
    link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6262182/",
    tags: [ "BU", "GI" ]
  },
  {
    name: "Jennifer S.",
    company: "LLS",
    role: "Sr. Manager, Volunteer Program Implementation",
    text: "Ellacard is easy to use and collaborate on. It has lots of designs to choose from and the function to add our own. Really professional and fun product to share internally and externally. Customer Service has been great.",
    src: 'Capterra',
    link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6299554/",
    tags: [ "BU", "GR" ]
  },
  {
    name: "Heather C.",
    company: "iResponze",
    role: "Senior Director, People Operations",
    text: "I love using Ellacard! It’s been a fantastic tool for our team, making it easy to stay connected and show appreciation across distances. The gift card feature is especially great, allowing our associates to choose the gift card they want, which adds a personal and flexible touch. Highly recommend it for remote teams!",
    src: 'Capterra',
    link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6518940/",
    tags: [ "BU", "GR", "GI" ]
  },
  {
    name: "Jacqueline C.",
    company: "Edward Jones",
    role: "Branch Office Administrator",
    text: "Ellacard is fantastic! They have a wide selection of cards and the interactive part has been fun, we have had feedback from our receiving end that they really enjoyed their cards.",
    src: 'Capterra',
    link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6517721/",
    tags: [ "BU", "GR" ]
  },
  {
    name: "Gary M.",
    company: "Kaplan",
    role: "Director",
    text: "This is an affordable platform for employee engagement and recognition. It offers a variety of options and with a creative mind and willingness to promote the use internally, it becomes an asset that everyone loves.",
    src: 'Capterra',
    link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6520961/",
    tags: [ "BU", "GR", "GI" ]
  },
  {
    name: "Arielle P.",
    company: "McKinsey",
    role: "Partner",
    text: "I used Ellacard to bulk send about 25 congratulations videos from our team to job candidates we’d made offers to, and it was so easy to set up. I just shared a link with my staff, and they recorded themselves without any trouble. The final videos came out looking really professional with effects and the candidates name in it, etc. I didn’t have to do much at all, which was a huge relief since I’m not great with video stuff.",
    tags: [ "BU", "VI" ]
  },
  {
    name: "Richard B.",
    text: "I switched to sending digital gift cards to my staff this year for the Holidays. I chose Ellacard because of their customization options and I liked that they let each person choose their own gift card. Their system also let my staff send a reply to their cards, which was a great personal touch.",
    src: 'Trustpilot',
    link: "https://www.trustpilot.com/reviews/671cf5ac69c34714ed940386",
    tags: [ "BU", "GI", "HO" ]
  },
  // {
  //   name: "Monique D.",
  //   company: "Highwire",
  //   role: "People Ops Specialist",
  //   text: "My experience with the platform has been overwhelmingly positive. The interface is intuitive and user-friendly, making it easy to navigate. Whether I'm creating a card for a special occasion or exploring new features, everything feels streamlined and accessible. The platform’s ease of use has saved me time and effort, allowing me to focus more on personalizing the content and less on the technical aspects. Overall, it's been a smooth and enjoyable experience. I also really appreciate how responsive the team is whenever I need guidance or encounter an issue. They take my feedback seriously and are genuinely committed to improving the platform. It's clear that they're always looking for ways to enhance the user experience, and I've noticed significant improvements over time. These continuous updates have made Ellacard even more user-friendly, elevating my overall experience with the platform. I use it on behalf of my company (especially the schedule send feature) for birthdays and other special occasions, and I love how we can attach gift cards and explore their other creative features.\n\nI like that you can create bulk gift card orders and customize each out with any custom field you want. This allows our cards to feel customized and personal. It also allows us to use EllaCard for a variety of use cases, since the possibilities for custom fields are endless.",
  //   src: 'capterra',
  //   link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6521055/",
  //   tags: [ "BU" ]
  // },
  {
    name: "Monique D.",
    company: "Highwire",
    role: "People Ops Specialist",
    text: "My experience with the platform has been overwhelmingly positive. The interface is intuitive and user-friendly, making it easy to navigate. Whether I'm creating a card for a special occasion or exploring new features, everything feels streamlined and accessible. The platform’s ease of use has saved me time and effort, allowing me to focus more on personalizing the content and less on the technical aspects. Overall, it's been a smooth and enjoyable experience.",
    src: 'Capterra',
    link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6521055/",
    tags: [ "BU", "IN" ]
  },
  {
    name: "Sonja P.",
    role: "Director, Operational Excellence",
    text: "We had an amazing experience using Ellacard for our Holiday cards this year! The ability to customize our cards with our company logo and colors was fantastic, and sending them from our own email address added a personal touch. I had a question about bulk sending, and their team responded within the hour with incredibly helpful information. It was such a refreshing change from what I'm used to. I highly recommend Ellacard!",
    src: 'Capterra',
    link: "https://www.capterra.com/p/214321/Ellacard/reviews/Capterra___6540774/",
    tags: [ "BU", "HO" ]
  },
  {
    name: "Whitney Pratt",
    text: "I ordered a video Ellacard for my parents' 50th anniversary and it was a hit! I sent it to all of their friends and family to provide a brief video clip of them wishing my parents a happy anniversary and a quick story of something fun that they remember doing with my parents, as well as add in any pictures they had from their time with them. My parents loved it!! They've watched 15+ times already and it was 45 minutes long after all of the various contributions!",
    src: 'Google',
    link: "https://maps.app.goo.gl/zK9jWRUP79XbScRCA",
    tags: [ "VI", "CO" ]
  },
  {
    name: "Arjun Iyer",
    role: "CEO",
    text: "I've used this site a few times, and I’m so glad I found it. I used them for a colleague’s birthday card, a new baby card, and a farewell card. I like how many features their cards have–they really make a difference. With the cards it was easy to email the link to everyone so they could add their own personal messages. There were a bunch of cute photos and nice messages. Each time the recipient loved it!",
    src: 'Trustpilot',
    link: "https://au.trustpilot.com/reviews/6706cef9a92d94c71a7a840f",
    tags: [ "GR", "BU" ]
  },
];


// Standard tags:
// GRoup, VIdeo, INvitation, HOliday, COnsumer, BUsiness, GIft cards


export default {
  name: 'start-reviews',

  components: { QuoteCard, StartLayer },

  props: [ 'tag' ],

  computed: {
    reviews() {
      return _.shuffle(REVIEWS.filter(x => !this.tag || x.tags.includes(this.tag)).slice(0, 8));
    }
  }
}
</script>
